import React from 'react';
import { ArrowUpRight, Check, TrendingUp } from 'lucide-react';

export function AuthHero({ signUp = false }: { signUp?: boolean }) {
  return (
    <section className="sticky top-0 z-10 -mx-4 flex h-[220px] w-[calc(100%+2rem)] flex-col justify-between overflow-hidden border border-[#b8e35c]/20 bg-[#245743] p-5 text-white shadow-xl sm:mx-0 sm:h-[360px] sm:w-full sm:p-8 lg:top-0 lg:h-screen lg:min-h-screen lg:max-h-none">
      <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full border-[36px] border-[#b8e35c]/20" />
      <div className="absolute -bottom-28 -left-24 h-72 w-72 rounded-full bg-[#b8e35c]/10" />

      <div className="relative">
        <div className="flex items-center justify-between gap-4">
          <img src="/PellvrfullLogotrans_opposite.png" alt="Pellvr" className="h-10 w-auto object-contain object-left" />
          <span className="rounded-full border border-[#b8e35c]/40 px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.16em] text-[#b8e35c]">Store operations</span>
        </div>
        <div className="mt-4 max-w-md sm:mt-12 lg:mt-16">
          <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.18em] text-[#b8e35c] sm:mb-4 sm:text-xs">Profit intelligence</p>
          <h2 className="text-2xl font-bold leading-[1.05] tracking-tight sm:text-4xl">
            {signUp ? 'Turn every store decision into a smarter move.' : 'Know where your margin is moving.'}
          </h2>
          <p className="mt-3 max-w-sm text-xs leading-5 text-[#d5e2d8] sm:mt-5 sm:text-base sm:leading-7">
            Pellvr turns POS, inventory, vendor, and pricing data into clear actions for modern convenience stores and gas stations.
          </p>
        </div>
      </div>

      <div className="relative mt-4 space-y-2 sm:mt-10 sm:space-y-3">
        <div className="hidden rounded-2xl border border-white/15 bg-[#16251e]/70 p-3 backdrop-blur-sm sm:block sm:p-4">
          <div className="mb-1 flex items-center justify-between text-[10px] text-[#c8d8cc] sm:mb-3 sm:text-xs">
            <span className="flex items-center gap-2"><TrendingUp size={15} className="text-[#b8e35c]" /> Today&apos;s signal</span>
            <ArrowUpRight size={15} className="text-[#b8e35c]" />
          </div>
          <p className="text-xs font-semibold sm:text-sm">Margin opportunity found</p>
          <p className="mt-1 text-[10px] text-[#aebfb2] sm:text-xs">Supplier costs and shelf prices are ready for review.</p>
        </div>
        <div className="flex flex-wrap gap-x-3 gap-y-1 text-[10px] text-[#d5e2d8] sm:gap-x-5 sm:gap-y-2 sm:text-xs">
          {['See profit leaks', 'Track inventory', 'Act with confidence'].map(item => (
            <span key={item} className="flex items-center gap-1.5"><Check size={13} className="text-[#b8e35c]" />{item}</span>
          ))}
        </div>
      </div>
    </section>
  );
}